<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Refer and earn sale report</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>
              <li class="breadcrumb-item active">Refer and earn sale report</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="show_filter = !show_filter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username"
                    >Referrer Username</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="username"
                        class="form-control"
                        v-model="filter.referrer"
                        placeholder="Username"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at"
                    >Date range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.created_at"
                        range
                        lang="en"
                        format="YYYY-MM-DD"
                        confirm
                        id="created_at"
                        value-type="YYYY-MM-DD"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive p-0">
            <table class="table">
              <thead>
              <tr>
                <th>Referrer Username</th>
                <th>Purchaser Username</th>
                <th>Courses</th>
                <!--<th>Subscription/Bundles</th>-->
                <th>Course price</th>
                <th>Cashback amount (20%)</th>
                <!--<th>Status</th>-->
                <th>CreatedAt</th>
              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="(order, index) in orders.data" :key="index">
                <td>{{ order.referrer ? order.referrer.username : "" }}</td>
                <td>{{ order.buyer ? order.buyer.username : "" }}</td>
                <td>
                    <span
                      class="badge bg-success"
                      v-for="(item, id) in order.courses"
                      :key="id"
                    >{{ item.course_title }} <br
                    /></span>
                </td>
                <!--<td>
                    <span
                      class="badge bg-success"
                      v-for="(itemBundle, id) in order.bundles"
                      :key="id"
                    >{{ itemBundle.bundle_title }}</span
                    >
                </td>-->
                <td>{{ order.actual_price - order.discount }}</td>
                <td>{{ (order.actual_price - order.discount) | referrer_profit(order.referral_discount, order.sub_payment_status) }}</td>
                <!--<td>
                  {{
                    Object.keys(orderStatus).find(
                      (key) =>
                        orderStatus[key] === parseInt(order.order_status)
                    )
                  }}
                </td>-->
                <td>
                  {{ order.created_at | moment }}
                </td>
              </tr>
              </tbody>
            </table>
            <div class="p-4"
              v-if="_.isEmpty(orders.data) && is_loading === false"
            >
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="orders"
              v-if="orders.total > orders.per_page"
              @paginate="getOrders()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Filters from './components/OrderFilter.vue'
import { LearningReportApi } from '@/services/api'
import axios from 'axios'

const fileDownload = require('js-file-download')

export default {
  name: 'ReferAndEarnSaleReport',
  metaInfo: {
    title: 'ReferAndEarnSaleReport | Dotlines',
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
    Filters,
  },
  data: () => ({
    orders: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },

    show_filter: false,
    filter: {},
    is_loading: false,
    orderStatus: [],
  }),
  mounted: function () {
    this.getOrders()
  },
  methods: {
    getOrders() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query))
      if (!_.isEmpty(this.filter)) this.showFilter = true
      this.is_loading = true
      let params = { ...this.filter, ...this.$route.query }
      LearningReportApi.referAndEarnSaleReport(params)
        .then((response) => {
          this.orders = response.orders
          this.orderStatus = response.settings
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    updateFilter(val) {
      this.filter = val.filter
      this.getOrders()
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err)
        })
    },
    resetFilter() {
      this.$router.push({path: this.$route.path}).catch(() => {
      })
    },
    exportFile: function () {
      this.is_loading = true
      axios
        .get('/reports/refer-and-earn-sales-report-export', {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          console.log(response.data)
          fileDownload(response.data, 'ReferAndEarnSaleReport.xlsx')
        })
        .catch((error) => {
          console.log("error " + error)
        })
        .finally(() => {
          this.is_loading = false
        })
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    },
    referrer_profit: function (value, referral_discount, sub_payment_status) {
      if (sub_payment_status == 3) {
        return (referral_discount > 0) ? value * 0.2 : 0.00
      } else {
        return 0.00 // value * 0.2
      }
    }
  },
}
</script>
